export default __webpack_public_path__ + "static/media/aws.4501f3b9.svg";